'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadRequest = loadRequest;
exports.loadBooked = loadBooked;
exports.loadPassed = loadPassed;
exports.loadOther = loadOther;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_REQUEST = 'redux-frontend/bookingList/LOAD_REQUEST';
var LOAD_REQUEST_SUCCESS = 'redux-frontend/bookingList/LOAD_REQUEST_SUCCESS';
var LOAD_REQUEST_FAIL = 'redux-frontend/bookingList/LOAD_REQUEST_FAIL';

var LOAD_BOOKED = 'redux-frontend/bookingList/LOAD_BOOKED';
var LOAD_BOOKED_SUCCESS = 'redux-frontend/bookingList/LOAD_BOOKED_SUCCESS';
var LOAD_BOOKED_FAIL = 'redux-frontend/bookingList/LOAD_BOOKED_FAIL';

var LOAD_PASSED = 'redux-frontend/bookingList/LOAD_PASSED';
var LOAD_PASSED_SUCCESS = 'redux-frontend/bookingList/LOAD_PASSED_SUCCESS';
var LOAD_PASSED_FAIL = 'redux-frontend/bookingList/LOAD_PASSED_FAIL';

var LOAD_OTHER = 'redux-frontend/bookingList/LOAD_OTHER';
var LOAD_OTHER_SUCCESS = 'redux-frontend/bookingList/LOAD_OTHER_SUCCESS';
var LOAD_OTHER_FAIL = 'redux-frontend/bookingList/LOAD_OTHER_FAIL';

var initialState = {
  loaded: false,
  request: [],
  booked: [],
  passed: [],
  other: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_REQUEST:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_REQUEST_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        request: action.result,
        error: null
      });
    case LOAD_REQUEST_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        request: [],
        error: action.result
      });
    case LOAD_BOOKED:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_BOOKED_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        booked: action.result,
        error: null
      });
    case LOAD_BOOKED_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        booked: [],
        error: action.result
      });
    case LOAD_PASSED:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_PASSED_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        passed: action.result,
        error: null
      });
    case LOAD_PASSED_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        passed: [],
        error: action.result
      });
    case LOAD_OTHER:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_OTHER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        other: action.result,
        error: null
      });
    case LOAD_OTHER_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        other: [],
        error: action.result
      });
    default:
      return state;
  }
}

function loadRequest() {
  return {
    types: [LOAD_REQUEST, LOAD_REQUEST_SUCCESS, LOAD_REQUEST_FAIL],
    promise: function promise(client) {
      return client.get('/bookings?type=requested');
    }
  };
}

function loadBooked() {
  return {
    types: [LOAD_BOOKED, LOAD_BOOKED_SUCCESS, LOAD_BOOKED_FAIL],
    promise: function promise(client) {
      return client.get('/bookings?type=booked');
    }
  };
}

function loadPassed() {
  return {
    types: [LOAD_PASSED, LOAD_PASSED_SUCCESS, LOAD_PASSED_FAIL],
    promise: function promise(client) {
      return client.get('/bookings?type=passed');
    }
  };
}

function loadOther() {
  return {
    types: [LOAD_OTHER, LOAD_OTHER_SUCCESS, LOAD_OTHER_FAIL],
    promise: function promise(client) {
      return client.get('/bookings?type=other');
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/bookingList.js
// module id = 478
// module chunks = 47